<template>
      <div class="stepper-nav flex-cente">
        <div class="stepper-item me-2" v-for="(step, index) in stepCount" :key="'step-nav-item-'+index" data-kt-stepper-element="nav" :class="{ 'current': activeStep === index + 1 }">
            <div class="stepper-wrapper d-flex align-items-center">
                <div class="stepper-icon" style="min-width: 40px; min-height: 40px;">
                    <i class="stepper-check fas fa-check" style="color: white !important;"></i>
                    <span class="stepper-number">{{index+1}}</span>
                </div>
                <div class="stepper-label">
                    <h3 class="stepper-title text-uppercase fs-4">
                      {{ step }}
                    </h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
  stepCount: { type: Number, required: true },
  activeStep: Number
})
</script>
<style>
.stepper.stepper-pills.stepper-column .stepper-item {
  padding-bottom: 3px !important; 
  padding-top: 3px !important; 
}
.stepper.stepper-pills .stepper-item.current .stepper-icon {
  transition: color .2s ease, background-color .2s ease;
  background-color: var(--bs-primary) !important;
}
</style>